exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-column{position:relative;margin-bottom:1.5rem}@media screen and (min-width:36.5em){.form-column{width:calc(50% - 1rem);margin-bottom:0}.form-column.three-wide{width:calc(33.33333% - .6666667rem)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/FormColumn/FormColumn.scss
// module id = 676
// module chunks = 0